import { isLinkActive } from '@sohanemon/utils';
import { useLocation } from '@tanstack/react-router';
import { useSyncExternalStore } from 'react';

export const useDraft = () => {
	const location = useLocation();
	const currentPath = location.pathname;
	const isDraftPage = isLinkActive({
		targetPath: '/draft',
		currentPath,
		exact: false,
	});

	const isInIframe = useSyncExternalStore(
		() => () => {},
		() => Boolean(typeof window !== 'undefined' && window.isIframe),
		() => false,
	);

	return {
		active: isDraftPage || isInIframe,
		isDraftPage,
		isInIframe,
	};
};
